import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ForgeGlobalPageExtensionPoint: LoadableType<{
	appId: string;
	envId: string;
	forgeManifestRoute: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalPage" */ './GlobalPage.tsx')).GlobalPage,
});
